module.exports = __webpack_public_path__ + "img/no-image-icon.d01227d3.png";